import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Box, Typography } from '@heycater/design-system';

import Accordion from 'shared/components/Accordion';
import Container from 'system/components/Container';

function Faqs({ faqs, faqHeadline }) {
  return (
    <Box as="section" mb={4}>
      <Container size="sm">
        <Box textAlign="center">
          <Typography variant="h3" mt={4} mb={6} component="h2">
            {faqHeadline}
          </Typography>
        </Box>
        <Box>
          {faqs.map((faq) => (
            <Accordion
              key={faq.objectID}
              summary={faq.fields.question}
              details={documentToReactComponents(faq.fields.answer)}
            />
          ))}
        </Box>
      </Container>
    </Box>
  );
}

export default Faqs;
